import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import API_BASE_URL from '../../config/api';
import './CarCard.css';

// 🎨 Importă iconițele
import { BsCalendar3 } from 'react-icons/bs';
import { GiGearStickPattern } from 'react-icons/gi';
import { MdLocalGasStation } from 'react-icons/md';
import { FaTachometerAlt, FaCar } from 'react-icons/fa';
import { TbEngine } from 'react-icons/tb';
import { AiFillThunderbolt } from 'react-icons/ai';

const CarCard = ({ car }) => {
  const navigate = useNavigate();
  const [currentImageIndex, setCurrentImageIndex] = useState(0);

  if (!car) {
    console.warn('CarCard: car prop is undefined');
    return null;
  }

  console.log('CarCard received car:', {
    _id: car._id,
    slug: car.slug,
    marca: car.marca,
    model: car.model
  });

  const getCarImages = () => {
    const images = car.imagini || [];
    if (images.length === 0 && car.imagineaPrincipala) {
      return [car.imagineaPrincipala.startsWith('http') ? car.imagineaPrincipala : `${API_BASE_URL}${car.imagineaPrincipala}`];
    }
    if (images.length === 0) return ['/placeholder-car.jpg'];
    return images.map(img => (img.startsWith('http') ? img : `${API_BASE_URL}${img}`));
  };

  const images = getCarImages();
  const hasMultipleImages = images.length > 1;

  const handlePrevImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const handleNextImage = (e) => {
    e.stopPropagation();
    setCurrentImageIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  const handleDotClick = (index, e) => {
    e.stopPropagation();
    setCurrentImageIndex(index);
  };

  const handleDetailsClick = () => {
    const identifier = car.slug || car._id;
    
    if (!identifier) {
      console.error('❌ CarCard: Missing car._id or car.slug', car);
      alert('Eroare: ID-ul mașinii lipsește');
      return;
    }
    
    console.log('✅ Navigating to:', `/masini/${identifier}`);
    navigate(`/masini/${identifier}`);
  };

  const formatPrice = (price) => price ? new Intl.NumberFormat('ro-RO').format(price) : 'N/A';
  const formatKilometraj = (km) => km ? new Intl.NumberFormat('ro-RO').format(km) : 'N/A';

  return (
    <div className="car-card" onClick={handleDetailsClick}>
      <div className="car-card-image-container">
        <img
          src={images[currentImageIndex]}
          alt={`${car.marca || ''} ${car.model || ''}`}
          className="car-card-image"
          onError={(e) => (e.target.src = '/placeholder-car.jpg')}
        />

        <div className="car-card-badge luxury-badge">LUXURY</div>

        {hasMultipleImages && (
          <>
            <button className="car-card-nav-btn car-card-nav-prev" onClick={handlePrevImage}>‹</button>
            <button className="car-card-nav-btn car-card-nav-next" onClick={handleNextImage}>›</button>
            <div className="car-card-dots">
              {images.map((_, index) => (
                <span
                  key={index}
                  className={`dot ${index === currentImageIndex ? 'active' : ''}`}
                  onClick={(e) => handleDotClick(index, e)}
                ></span>
              ))}
            </div>
          </>
        )}
      </div>

      <div className="car-card-content">
        <div className="car-card-header">
          <h3 className="car-card-title">{car.marca || ''} {car.model || ''}</h3>
          <p className="car-card-subtitle">{car.transmisie || ''}</p>
        </div>

        <div className="car-card-price-section">
          <div className="car-card-price">{formatPrice(car.pret)} <span style={{color:'white'}} className="currency">EUR</span></div>
          <div style={{color:'white'}} className="car-card-location">{car.locatie || 'București'}</div>
        </div>
        
        <div className="car-card-features">
          {car.tvaDeductibil && <span className="car-card-badge-sm">TVA Nedeductibil</span>}
          {car.garantieInclusa && <span className="car-card-badge-sm green">Garanție inclusă</span>}
        </div>

        {/* ✨ SECȚIUNE NOU CU ICONIȚE - Grid 3x2 */}
        <div className="car-card-icon-grid">
          <div className="car-card-icon-item">
            <BsCalendar3 className="car-icon" />
            <div className="car-icon-text">
              <span className="car-icon-label">An fabricație</span>
              <span className="car-icon-value">{car.anFabricatie || 'N/A'}</span>
            </div>
          </div>

          <div className="car-card-icon-item">
            <TbEngine className="car-icon" />
            <div className="car-icon-text">
              <span className="car-icon-label">Capacitate motor</span>
              <span className="car-icon-value">{car.capacitateCilindrica || 'N/A'} CC</span>
            </div>
          </div>

          <div className="car-card-icon-item">
            <MdLocalGasStation className="car-icon" />
            <div className="car-icon-text">
              <span className="car-icon-label">Combustibil</span>
              <span className="car-icon-value">{car.carburant || 'N/A'}</span>
            </div>
          </div>

          <div className="car-card-icon-item">
            <GiGearStickPattern className="car-icon" />
            <div className="car-icon-text">
              <span className="car-icon-label">Transmisie</span>
              <span className="car-icon-value">{car.transmisie || 'N/A'}</span>
            </div>
          </div>

          <div className="car-card-icon-item">
            <FaCar className="car-icon" />
            <div className="car-icon-text">
              <span className="car-icon-label">Caroserie</span>
              <span className="car-icon-value">{car.caroserie || 'Berlină'}</span>
            </div>
          </div>

          <div className="car-card-icon-item">
            <FaTachometerAlt className="car-icon" />
            <div className="car-icon-text">
              <span className="car-icon-label">Kilometraj</span>
              <span className="car-icon-value">{formatKilometraj(car.kilometraj)}</span>
            </div>
          </div>
        </div>

        {/* Rândul cu putere (opțional - poate fi adăugat în grid dacă vrei) */}
        {/* <div className="car-card-power-row">
          <AiFillThunderbolt className="power-icon" />
          <span>{car.putere || 'N/A'} CP</span>
        </div> */}

        <button className="car-card-details-btn" onClick={handleDetailsClick}>Detalii</button>
      </div>
    </div>
  );
};

export default CarCard;